/* @flow */
/* eslint-env es6,browser */

import { getCookie } from './cookie';
import { logDebug } from './logger';

/**
 * @module utils/ccpautils
 * @description CCPA Utility functions
 * @requires utils/cookie
 */

const USP_STRING_TTL: number = 30; // local USP String validity in seconds
const CCPA_OPTED_OUT_STRING: string = '1YYN'; // LoggedIn + CCPA Opt-out
const CCPA_DEFAULT_STRING: string = '1---'; // Not logged in (state unknown)
const CCPA_VERSION: number = 1;

/** US Privacy Cookie key */
const CCPA_COOKIE_KEY: string = 'usprivacy';

/** CCPA Commands */
const CCPA_CMD_GET_USP_DATA: string = 'getUSPData';
/** CCPA Commands End */

const GDPR_COOKIE_KEY: string = 'u_consent';
const gdprConsentCookieValue: string = getCookie(GDPR_COOKIE_KEY) || '';

/** local cached CCPA USP String */
let uspString: string = CCPA_DEFAULT_STRING;
/** last updated time for uspString */
let lastUspStringUpdated: number = 0;

/**
 * Get GDPR consent string
 * @returns {string} - GDPR consent value
 */
export function getGDPRConsent(): string {
  return gdprConsentCookieValue;
}

/**
 * Check if from EU region
 * @returns {boolean} - From EU/not
 */
export function isFromEU(): boolean {
  return getGDPRConsent().length > 0;
}

/**
 * Gets CCPA String
 *
 * @returns {string} - CCPA String
 */
export function getCCPA(ignoreTTL: boolean = false): string {
  /**
   * Return locally cached CCPA USP string ( local cache is updated everytime as.get is called )
   */

  if (isFromEU()) {
    // consider all traffic from EU as CCPA opted-out irrespective of the customer preference
    return CCPA_OPTED_OUT_STRING;
  }

  // Can we use the cached one?
  const curTime = Date.now() / 1000;
  if (
    !ignoreTTL &&
    lastUspStringUpdated > 0 &&
    curTime - lastUspStringUpdated <= USP_STRING_TTL
  ) {
    return uspString;
  }

  // fetch from cookie and update
  uspString = getCookie(CCPA_COOKIE_KEY) || CCPA_DEFAULT_STRING;
  lastUspStringUpdated = curTime;
  logDebug(
    `CCPA UPDATE: uspString : ${uspString}, lastUspStringUpdated : ${lastUspStringUpdated}`
  );
  return uspString;
}

/**
 * Gets CCPA Opt-Out state
 *
 * @returns {boolean} - CCPA Out-Out state
 */
export function isCCPAOptedOut(): boolean {
  return getCCPA() === CCPA_OPTED_OUT_STRING; // True only if [ LoggedIn + CCPA Opt-out  OR from EU]
}

window.__uspapi =
  window.__uspapi ||
  function __uspapi(command: string, version: number, callback: uspCallback) {
    /* Version Check? */
    if (command === CCPA_CMD_GET_USP_DATA) {
      /* Get CCPA Cookie value */
      const ccpaValue = getCCPA();
      /* Call callback with cookie value & CCPA version */
      callback(
        {
          version: CCPA_VERSION,
          uspString: ccpaValue
        },
        true
      );
    }
  };
